import "./investment-calculator";



// WEBPACK FOOTER //
// ./project/client/src/site__horticulture/components/investment-calculator/index.js